export default __webpack_public_path__ + "static/media/bootcampDiariesOutlined.89443ba2.png";